import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
    return (
        <Box
            sx={{
                py: 2,
                minWidth: "100%",
                display: "flex",
                justifyContent: "center"
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default Loader;